import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyEmail } from "../services/auth";

export default function VerifyEmail() {
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setState("error");
      setMessage("Doğrulama token'ı bulunamadı.");
      return;
    }

    verifyEmail(token)
      .then((data) => {
        setState("success");
        setMessage(data.message || "E-posta adresiniz başarıyla doğrulandı!");
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      })
      .catch((error) => {
        setState("error");
        const errorMsg =
          error.response?.data?.detail ||
          "Doğrulama başarısız. Link geçersiz veya süresi dolmuş olabilir.";
        setMessage(errorMsg);
      });
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 to-indigo-700 p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        {state === "loading" && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              E-posta Doğrulanıyor...
            </h2>
            <p className="text-gray-600">Lütfen bekleyin</p>
          </div>
        )}

        {state === "success" && (
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              ✅ Başarılı!
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500">
              3 saniye içinde giriş sayfasına yönlendiriliyorsunuz...
            </p>
            <button
              onClick={() => navigate("/login")}
              className="mt-4 text-purple-600 hover:text-purple-700 font-medium"
            >
              Hemen giriş yap →
            </button>
          </div>
        )}

        {state === "error" && (
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              ❌ Doğrulama Başarısız
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <button
              onClick={() => navigate("/login")}
              className="mt-4 bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition"
            >
              Giriş Sayfasına Dön
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
